const cmpy = {
    name : "J & M Tech Solutions",
    mobile : "+91 95387 77965",
    mail : "jmtechsolution2024@gmail.com",
    address : "891, 7th Main Rd, Prakash Nagar, Rajajinagar, Bengaluru, Karnataka 560021",
}

export default cmpy;